// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.ordercollections', {
        url: '/ordercollections',
        views: {
            'baseList': {
            templateUrl: 'main/base/ordercollections/ordercollections.tpl.html',
            controller: 'OrderCollectionsController as vm'
        }},
        resolve: {
            collections: collectionsResolver
        }
    });
}

// @ngInject
function collectionsResolver(OrderCollectionsApiService) {
    return OrderCollectionsApiService.listAllOrderCollections();
}

// @ngInject
function OrderCollectionsController($rootScope, $state, $scope, collections, OrderCollectionsApiService, loadSpinnerService) {
    var vm = this;

    //Properties
    vm.currentUser = $rootScope.currentUser;
    vm.collections = collections;
    vm.selectedCollectionId = 0;
    vm.searchTerm = '';
    vm.currentPage = 1;

    //Methods
    vm.searchTermChange = searchTermChange;
    vm.getFullDate = getFullDate;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.collectionId; }, function(newValue, oldValue) {
            vm.selectedCollectionId = parseInt($state.params.collectionId,10);
        });
        $rootScope.$on('OrderCollection.Inserted', function(event, response) {
        });
        $rootScope.$on('OrderCollection.Updated', function(event, response) {
        });
        $rootScope.$on('OrderCollection.Deleted', function(event, response) {
        });
        $rootScope.$on('OrderCollection.Changed', function(event, response) {
            loadCollections();
        });
    }

    function loadCollections() {
        loadSpinnerService.start('mainSpinner');
        OrderCollectionsApiService.listAllOrderCollections().then(function(response) {
            vm.collections = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadCollections();
    }

    function getFullDate(date) {
        var year = new Date(date).getFullYear();
        var month = zeroFill(new Date(date).getMonth() + 1, 2);
        var day = zeroFill(new Date(date).getDate(), 2);

        return '' + year + '-' + month + '-' + day;
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            // eslint-disable-next-line wrap-regex
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }
}

angular
    .module('base.ordercollections', ['ordercollections.api', 'ordercollections.ordercollection'])
    .config(stateConfig)
    .controller('OrderCollectionsController', OrderCollectionsController);
